var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleTargetGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 656,
    height: 369,
    viewBox: "0 0 656 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 656,
    height: 369,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 65,
    width: 237.5,
    height: 46,
    rx: 3,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 65,
    width: 237.5,
    height: 46,
    rx: 3,
    stroke: "#F2F2F2",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 128,
    width: 239.5,
    height: 48,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 192,
    width: 239.5,
    height: 48,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 256,
    width: 239.5,
    height: 48,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 344.5,
    y: 65,
    width: 237.5,
    height: 46,
    rx: 3,
    stroke: "#2D72FE",
    strokeWidth: 2,
    strokeDasharray: "0 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21130_327120)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.798 85.4311C568.188 85.0405 568.188 84.4074 567.798 84.0169L567.484 83.703C567.093 83.3125 566.46 83.3125 566.07 83.7031L556.408 93.3643L551.931 88.8871C551.541 88.4966 550.907 88.4966 550.517 88.8871L550.203 89.2009C549.813 89.5914 549.813 90.2246 550.203 90.6151L555.701 96.113C555.897 96.3091 556.154 96.4067 556.411 96.4058C556.666 96.4052 556.921 96.3075 557.116 96.113L567.798 85.4311Z",
    fill: "#2D72FE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.523 84.8655L445.588 100.68L428.36 98.8912L438.523 84.8655ZM368.094 169.042L367.964 167.547L368.094 169.042ZM285.1 121.428C286.516 120.932 286.516 120.932 286.516 120.931C286.516 120.931 286.516 120.931 286.516 120.931C286.516 120.932 286.517 120.933 286.517 120.936C286.519 120.94 286.522 120.948 286.525 120.958C286.533 120.98 286.545 121.013 286.563 121.059C286.597 121.151 286.649 121.292 286.722 121.477C286.867 121.847 287.091 122.397 287.4 123.099C288.018 124.504 288.976 126.517 290.326 128.92C293.027 133.73 297.288 140.087 303.519 146.269C315.948 158.6 336.275 170.304 367.964 167.547L368.224 170.536C335.555 173.378 314.385 161.275 301.406 148.399C294.934 141.978 290.514 135.382 287.71 130.389C286.307 127.892 285.306 125.791 284.654 124.307C284.328 123.566 284.088 122.978 283.929 122.571C283.849 122.368 283.79 122.21 283.749 122.101C283.729 122.047 283.714 122.004 283.703 121.975C283.698 121.96 283.693 121.948 283.69 121.94C283.689 121.935 283.688 121.932 283.687 121.929C283.686 121.928 283.686 121.926 283.685 121.926C283.685 121.925 283.685 121.924 285.1 121.428ZM367.964 167.547C393.171 165.354 409.108 153.575 419.246 139.591C429.423 125.554 433.786 109.24 435.65 98.0469L438.609 98.5394C436.708 109.959 432.235 126.786 421.675 141.352C411.076 155.972 394.378 168.261 368.224 170.536L367.964 167.547Z",
    fill: "#D3D3D3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21130_327120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 76,
    width: 240,
    height: 48,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: 77.5,
    width: 237,
    height: 45,
    rx: 2.5,
    stroke: "#2D72FE",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21130_327120",
    x: 78,
    y: 58,
    width: 280,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21130_327120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21130_327120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21130_327120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(549 80)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleTargetGraphic);
export default __webpack_public_path__ + "static/media/singleTargetGraphic.88465233dd5c18c20f9d4f0958ac8a5e.svg";
export { ForwardRef as ReactComponent };